<template>
  <div class="redeem-page">
    <a-card title="激活码兑换" :bordered="false">
      <div class="redeem-form">
        <a-form
          :form="form"
          @submit="handleSubmit"
          layout="vertical"
        >
          <a-form-item label="激活码">
            <a-input
              v-decorator="[
                'activeCode',
                {
                  rules: [
                    { required: true, message: '请输入激活码' },
                    { min: 6, message: '激活码长度不能少于6位' }
                  ]
                }
              ]"
              placeholder="请输入激活码"
              size="large"
              :disabled="loading"
            />
          </a-form-item>
          
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              size="large"
              :loading="loading"
              block
            >
              立即兑换
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </a-card>

    <!-- 兑换成功结果 -->
    <a-card
      v-if="redeemResult"
      title="兑换成功"
      :bordered="false"
      style="margin-top: 20px;"
    >
      <div class="success-content">
        <a-icon type="check-circle" theme="twoTone" two-tone-color="#52c41a" style="font-size: 48px; margin-bottom: 16px;" />
        <h3>恭喜您！激活码兑换成功</h3>
        <p>您已获得以下权益：</p>
        
        <div class="entitlements-list">
          <a-tag
            v-for="(entitlement, index) in redeemResult.entitlements"
            :key="index"
            color="green"
            style="margin: 4px; padding: 8px 12px; font-size: 14px;"
          >
            {{ getEntitlementText(entitlement) }}
          </a-tag>
        </div>
        
        <div style="margin-top: 20px;">
          <a-button type="primary" @click="viewEntitlements">
            查看我的权益
          </a-button>
          <a-button style="margin-left: 8px;" @click="redeemAnother">
            继续兑换
          </a-button>
        </div>
      </div>
    </a-card>

    <!-- 我的权益 -->
    <a-card
      title="我的权益"
      :bordered="false"
      style="margin-top: 20px;"
    >
      <a-button
        type="primary"
        icon="reload"
        @click="loadEntitlements"
        :loading="entitlementsLoading"
        style="margin-bottom: 16px;"
      >
        刷新权益
      </a-button>
      
      <a-spin :spinning="entitlementsLoading">
        <div v-if="entitlements.length === 0" class="empty-state">
          <a-empty description="暂无权益" />
        </div>
        
        <div v-else class="entitlements-grid">
          <a-card
            v-for="entitlement in entitlements"
            :key="entitlement.id"
            size="small"
            :title="getEntitlementTitle(entitlement)"
            style="margin-bottom: 12px;"
          >
            <p><strong>学科：</strong>{{ entitlement.subject_name || '通用' }}</p>
            <p><strong>类型：</strong>{{ getItemTypeName(entitlement.item_type) }}</p>
            <p v-if="entitlement.target_id > 0">
              <strong>绑定内容：</strong>{{ entitlement.target_type }} ID: {{ entitlement.target_id }}
            </p>
            <p><strong>有效期：</strong>{{ formatValidUntil(entitlement.valid_until) }}</p>
            <p><strong>获得时间：</strong>{{ formatTime(entitlement.created_at) }}</p>
            <p v-if="entitlement.activation_code">
              <strong>激活码：</strong>{{ entitlement.activation_code }}
            </p>
          </a-card>
        </div>
      </a-spin>
    </a-card>
  </div>
</template>

<script>
import { redeemActivationCode, getUserEntitlements } from '@/libs/api'

export default {
  name: 'RedeemPage',
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      redeemResult: null,
      entitlements: [],
      entitlementsLoading: false
    }
  },
  
  mounted() {
    this.loadEntitlements()
  },
  
  methods: {
    async handleSubmit(e) {
      e.preventDefault()
      
      this.form.validateFields(async (err, values) => {
        if (err) return
        
        this.loading = true
        try {
          const response = await redeemActivationCode(values.activeCode)
          if (response.code === 1) {
            this.redeemResult = response.data
            this.form.resetFields()
            // 刷新权益列表
            this.loadEntitlements()
            this.$message.success('激活码兑换成功！')
          } else {
            this.$message.error(response.msg || '兑换失败')
          }
        } catch (error) {
          console.error('兑换失败:', error)
          this.$message.error('兑换失败，请稍后重试')
        } finally {
          this.loading = false
        }
      })
    },
    
    async loadEntitlements() {
      this.entitlementsLoading = true
      try {
        const response = await getUserEntitlements()
        if (response.code === 1) {
          this.entitlements = response.data.entitlements || []
        } else {
          this.$message.error(response.msg || '获取权益失败')
        }
      } catch (error) {
        console.error('获取权益失败:', error)
        this.$message.error('获取权益失败，请稍后重试')
      } finally {
        this.entitlementsLoading = false
      }
    },
    
    getEntitlementText(entitlement) {
      const typeName = this.getItemTypeName(entitlement.type)
      const subjectName = this.getSubjectName(entitlement.subject_id)
      return `${subjectName} · ${typeName}`
    },
    
    getEntitlementTitle(entitlement) {
      return entitlement.activation_name || '权益'
    },
    
    getItemTypeName(type) {
      const typeMap = {
        1: '含资料',
        2: '不含资料',
        'exam_paper': '电子真题',
        'question_bank': '会员题库',
        'course': '课程',
        'material': '资料'
      }
      return typeMap[type] || type
    },
    
    getSubjectName(subjectId) {
      // 这里可以从store或者API获取学科名称
      // 暂时返回ID
      return subjectId ? `学科${subjectId}` : '通用'
    },
    
    formatValidUntil(timestamp) {
      if (!timestamp || timestamp === 0) {
        return '永久有效'
      }
      return new Date(timestamp * 1000).toLocaleDateString()
    },
    
    formatTime(timestamp) {
      return new Date(timestamp * 1000).toLocaleString()
    },
    
    viewEntitlements() {
      // 滚动到权益区域
      const entitlementsCard = document.querySelector('.entitlements-grid').parentElement.parentElement
      entitlementsCard.scrollIntoView({ behavior: 'smooth' })
    },
    
    redeemAnother() {
      this.redeemResult = null
      this.form.resetFields()
    }
  }
}
</script>

<style scoped>
.redeem-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.redeem-form {
  max-width: 400px;
  margin: 0 auto;
}

.success-content {
  text-align: center;
  padding: 20px;
}

.entitlements-list {
  margin: 20px 0;
  text-align: left;
}

.entitlements-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.empty-state {
  text-align: center;
  padding: 40px;
}

@media (max-width: 768px) {
  .redeem-page {
    padding: 10px;
  }
  
  .entitlements-grid {
    grid-template-columns: 1fr;
  }
}
</style>